"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fontsUtils = require("promo-animation/dist/utils/fontsUtils");

var _animations = require("promo-animation/dist/animations");

var _gsap = require("gsap");

var errors = _interopRequireWildcard(require("./errors-const"));

var _utils = require("../utils");

var _typesConst = require("../const/types-const");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* map of ref to the animaton and tweens object
    {
        aniumation: js-animation object
        tweens: array of tweenMax tween
        destroyFunc: func destroy,
        el: dom element
        timing: {
            start,
            end,
            inDuration: animation.inDuration,
            outDuration: animation.outDuration,
        },
    }
*/
let map;
let container; // tween max timeline

let timeline;
let videoScale = 1;
const prefix = 'g';
const viewConfig = {
  width: 1280,
  height: 720
};
let customFonts = {};

function onScaleChange(scale) {
  _gsap.TweenMax.set(container, {
    width: viewConfig.width * scale,
    height: viewConfig.height * scale
  });

  map.forEach(animObj => {
    const {
      animation
    } = animObj;

    if (animation && animation.updateVideoScale) {
      animation.updateVideoScale(scale);
    }
  });
}

class CaptionsViewService {
  constructor(config) {
    if (config) {
      this.logger = config.logger || function () {};

      if (config.fonts) {
        customFonts = config.fonts;
      }
    } // load font to html page


    this.isFontLoaded = (0, _fontsUtils.LoadFonts)(customFonts); // set ref to container dom element

    const {
      wrapper
    } = config; // create a div in the wrapper

    container = document.createElement('div');
    container.id = 'caption-view';

    _gsap.TweenMax.set(container, {
      overflow: 'hidden',
      position: 'relative'
    });

    wrapper.appendChild(container); // set new map

    map = config.map; // set time line

    timeline = config.timeline; // set actions

    const {
      play,
      pause,
      time
    } = config;
    this.play = play;
    this.pause = pause;
    this.time = time;
  }

  set scale(scale) {
    onScaleChange(scale);
    videoScale = scale;
  }

  get scale() {
    return videoScale;
  }

  clear() {
    map.forEach((value, key) => {
      if (value && value.animation) {
        this.destroy(key);
      }
    });
  }

  onPlay() {
    if (this.idle) {
      this.idle.kill();
    }
  }

  async create(data, ratio) {
    if (!_.isString(ratio)) {
      throw errors.INVALID_PARMS;
    }

    if (!data) {
      throw errors.DECORATION_DATA_MISSING;
    }

    const {
      captions,
      watermarkData
    } = data;

    if (!captions && !watermarkData) {
      throw errors.DECORATION_DATA_MISSING;
    }

    await this.isFontLoaded;
    const {
      width,
      height
    } = (0, _utils.getRatioObjectBy)('ratio', ratio);
    viewConfig.width = width;
    viewConfig.height = height;

    _gsap.TweenMax.set(container, {
      width: width * videoScale,
      height: height * videoScale
    }); // clear timeline before creating new one


    this.clear();

    if (watermarkData && watermarkData.hasOwnProperty(_typesConst.WATERMARK)) {
      const outro = (0, _utils.getOutro)(captions);
      const timing = {
        start: 0,
        end: outro.timing.start
      };
      await this.render(_typesConst.WATERMARK, { ...watermarkData,
        timing
      }, _typesConst.WATERMARK);
    }

    await Promise.all(captions.map(async caption => {
      await this.render(caption.guid, captions, _typesConst.CAPTION);
    }));
  }

  async render(guid, data, type) {
    if (!_.isString(guid)) {
      throw errors.INVALID_PARMS;
    }

    if (!data) {
      throw errors.DECORATION_DATA_MISSING;
    }

    if (map.has(guid)) {
      this.destroy(guid);
    }

    let start;
    let end;
    let animatinoObject = {
      videoScale
    };

    if (type === _typesConst.WATERMARK) {
      // watermark animation
      const {
        timing
      } = data;
      start = timing.start;
      end = timing.end;
      animatinoObject = { ...animatinoObject,
        animationType: 'lottiewatermark',
        data
      };
    } else {
      // default caption
      const caption = (0, _utils.getCaptionByGuid)(data, guid);

      if (!caption) {
        throw errors.CAPTION_NOT_FOUND;
      }

      const {
        timing
      } = caption;
      start = timing.start;
      let lottie = (0, _utils.getFirstItemByLayout)(caption.children, 'lottie');

      if (!lottie) {
        lottie = (0, _utils.getFirstItemByLayout)(caption.children, 'lottietrustpilot');
      }

      const {
        id,
        inDuration,
        outDuration
      } = lottie.data;
      end = timing.end - outDuration / 1000; // set end time - out duration

      animatinoObject = { ...animatinoObject,
        animationType: 'lottie',
        animationId: id,
        data: lottie.data,
        inDuration,
        outDuration: outDuration || 1 // ensure that value is not 0 need to fixed in js-animation

      };
    }

    let animation = null;
    animation = (0, _animations.createAnimation)(animatinoObject);

    if (!animation) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    const el = document.createElement('span');
    el.id = `${prefix}-${guid}`;
    container.appendChild(el);
    animation.render(el);
    await new Promise((resolve, reject) => {
      let tweens = [];

      const ready = () => {
        this.logger.log('ready', guid);
        tweens = (0, _utils.getCaptionTweens)(guid, animation, _gsap.TweenMax, _gsap.Linear.easeNone);

        if (tweens[0]) {
          timeline.add(tweens[0], start);
        }

        if (tweens[1]) {
          timeline.add(tweens[1], end);
        }

        map.set(guid, { ...map.get(guid),
          tweens
        });
        resolve(animation);
      };

      const destroy = () => {
        this.logger.log('destroy', guid);
        tweens.forEach(tween => {
          tween.kill();
        });
        animation.removeEventListener('ready', ready);
        animation.destroy();
        container.removeChild(el);
        map.delete(guid);
        reject('destroy animation');
      };

      map.set(guid, {
        animation,
        destroyFunc: destroy,
        el,
        timing: {
          start,
          end,
          inDuration: animation.inDuration,
          outDuration: animation.outDuration
        }
      });
      animation.addEventListener('ready', ready);
    });
  }

  destroy(guid) {
    if (!_.isString(guid)) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    if (map.has(guid)) {
      const {
        destroyFunc
      } = map.get(guid);
      destroyFunc.call();
    }
  }

  goToIdle(guid, direct) {
    if (!_.isString(guid)) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    const {
      animation,
      timing,
      tweens
    } = map.get(guid);

    if (!animation) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    if (this.idle) {
      this.idle.kill();
    }

    const {
      start,
      inDuration
    } = timing;
    this.pause();

    if (direct || inDuration <= 1) {
      this.time(start);
      this.time(start + inDuration / 1000);
    } else {
      this.time(start);
      const duration = inDuration / 1000;

      const tween = _gsap.TweenMax.to({
        time: start
      }, duration, {
        time: start + duration,
        onStart: () => {
          this.logger.log('goToIdle - start');

          if (_.isFunction(this.onGoToIdleEvent)) {
            this.onGoToIdleEvent('GOTO_IDLE_START');
          }

          this.play(null, true); // set this tween for clean up

          this.idle = tween;
        },
        onComplete: () => {
          this.logger.log('goToIdle - complete');
          this.pause();

          if (_.isFunction(this.onGoToIdleEvent)) {
            this.onGoToIdleEvent('GOTO_IDLE_COMPLETE');
          }
        }
      }); // set and twenn on this current caption for clean up


      tweens.push(tween);
    }

    return true;
  }

  updateCaptionSizeAndPosition(guid, rect) {
    if (!_.isString(guid) || !rect) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    const {
      animation
    } = map.get(guid);
    let validateRect = { ...animation.style,
      ...rect
    };
    validateRect = (0, _utils.validateCaptionSizeAndPosition)(validateRect, {
      width: animation.width,
      height: animation.height
    }, viewConfig);

    if (animation.updateSizeAndPosition) {
      animation.updateSizeAndPosition(validateRect);
    } else {
      throw errors.INVALID_REQUEST;
    }

    return validateRect;
  }

  updateCaptionInputs(guid, inputs) {
    if (!inputs || !_.isObject(inputs)) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    const {
      animation
    } = map.get(guid);

    if (!animation.updateInput) {
      throw errors.INVALID_REQUEST;
    }

    Object.keys(inputs).forEach(key => {
      animation.updateInput(key, inputs[key]);
    });
    return true;
  }

  updateCaptionColors(guid, colors) {
    if (!_.isString(guid) || !colors) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    const {
      animation
    } = map.get(guid);

    if (!animation.updateInput) {
      throw errors.INVALID_REQUEST;
    }

    Object.keys(colors).forEach(key => {
      animation.updateInput(key, colors[key]);
    });
    return colors;
  }

  updateLogoSizeAndPosition(guid, rect) {
    if (!_.isString(guid) || !_.isObject(rect)) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    const {
      animation
    } = map.get(guid);
    animation.updateLogoSizeAndPosition(rect);
    return true;
  }

  updateLogoImageScale(guid, scale) {
    if (!_.isString(guid) || !_.isNumber(scale)) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.ANIMATION_NOT_RENDERED;
    }

    const {
      animation
    } = map.get(guid);
    animation.updateLogoScale(scale);
    return true;
  }

}

exports.default = CaptionsViewService;